import { FC } from 'react';
import { InboxMessagesPageProps } from '../../types';
import CleverlyEmailViewFilters from '../filters/cleverly';
import { InboxEmailViewProps } from '../page';

function withCleverlyFilter(Component: FC<InboxEmailViewProps>): FC<InboxMessagesPageProps> {
	return (props: InboxMessagesPageProps) => {
		const { filters, filterUpdateCallbacks, isTeamMembersFilterVisible } = props;
		return (
			<Component {...props}>
				<CleverlyEmailViewFilters
					filters={filters}
					filterUpdateCallbacks={filterUpdateCallbacks}
					isTeamMembersFilterVisible={isTeamMembersFilterVisible}
				/>
			</Component>
		);
	};
}

export default withCleverlyFilter;
